// extracted by mini-css-extract-plugin
module.exports = {"closeBigBtn":"PlasmicStandardButton_closeBigBtn__1dsMJ"};